// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Product Catalogue API
 * Endpoints for querying product catalogue data including products and their versions.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface GetLatestVersionResponse
 */
export interface GetLatestVersionResponse {
  /**
   * The latest version identifier.
   * @type {string}
   * @memberof GetLatestVersionResponse
   */
  version: string;
}

/**
 * Check if a given object implements the GetLatestVersionResponse interface.
 */
export function instanceOfGetLatestVersionResponse(
  value: object,
): value is GetLatestVersionResponse {
  if (!('version' in value) || value['version'] === undefined) return false;
  return true;
}

export function GetLatestVersionResponseFromJSON(
  json: any,
): GetLatestVersionResponse {
  return GetLatestVersionResponseFromJSONTyped(json, false);
}

export function GetLatestVersionResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GetLatestVersionResponse {
  if (json == null) {
    return json;
  }
  return {
    version: json['version'],
  };
}

export function GetLatestVersionResponseToJSON(
  json: any,
): GetLatestVersionResponse {
  return GetLatestVersionResponseToJSONTyped(json, false);
}

export function GetLatestVersionResponseToJSONTyped(
  value?: GetLatestVersionResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    version: value['version'],
  };
}
